import {useQuery} from "@tanstack/react-query";
import {teamMemberApiService} from "./teamMemberApi.service.js";

export const teamMemberKeysStore = {
  root: ["teamMember"] as const,
  allTeamMembers: () => [...teamMemberKeysStore.root, "all"] as const,
};

/**
 * Hook to get all team members
 * 📋 Fetches all team members (managers and workers)
 */
export function useTeamMembers() {
  const {data, isLoading, isFetching, refetch} = useQuery({
    queryKey: teamMemberKeysStore.allTeamMembers(),
    queryFn: teamMemberApiService.getTeamMembers,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    teamMembers: data,
    isTeamMembersLoading: isLoading,
    isTeamMembersFetching: isFetching,
    refetchTeamMembers: refetch,
  };
}
